import { useContext } from 'react'
import { WalletContext } from 'contexts/walletContext'

export const useWalletContext = () => useContext(WalletContext)
